const passwordRegex =
  /^(?=.*[A-Za-z])(?=.*\d|.*[!@#$%^&*()_+{}:"<>?;'[\],.\-]).{6,16}|(?=.*\d)(?=.*[!@#$%^&*()_+{}:"<>?;'[\],.\-]).{6,16}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const usernameRegex = /^.{6,}$/;
const phoneRegex = /^[0-9]{7,15}$/;

export const isValidEmail = (value: string): boolean => {
  if (!emailRegex.test(value)) return false;
  return true;
};

export const isValidPassword = (value: string): boolean => {
  if (!passwordRegex.test(value)) return false;
  return true;
};

export const isValidUsername = (value: string): boolean => {
  if (!usernameRegex.test(value)) return false;
  return true;
};

export const isValidMobileNumber = (value: string): boolean => {
  if (!phoneRegex.test(value)) return false;
  return phoneRegex.test(value);
};

export const isVideo = (url: string): boolean => {
  const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi", "mkv", "flv"];
  const extension = url.split(".").pop()?.toLowerCase() || "";
  return videoExtensions.includes(extension);
};

export const isImage = (url: string): boolean => {
  const imageExtensions: string[] = [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "svg",
    "webp",
  ];
  const extension = url.split(".").pop()?.toLowerCase() || "";
  return imageExtensions.includes(extension);
};
